module.exports = __webpack_public_path__ + "static/media/estadoproyecto.0f7715c0.png";